import { term } from '../../../PwcTerm/mixin/term'
import getConfig from '@/config/index'
import RouterName from '@/constants/route'

export const logic = {
  inject: ['home'],
  mixins: [term],
  methods: {
    handleRegister(product) {
    //   this.showTerm(product.productTerm)
      this.$router.replace({
        name: RouterName.registerForm,
        query: {
          product: product.id,
          type: product.programmeTypeName.toLowerCase().includes('anchor') ? 0 : 1,
          name: product.name,
          formType: product.formType,
          campaignCode: product.campaignCode,
          t: new Date().getTime()
        }
      })
    }
    // handleConfirm() {
    // }
  },
  computed: {
    cProductList() {
      return (this.home.applyLookups.products || []).map(v => {
        return Object.assign({}, v, {
          coverUrl: getConfig().PUBLIC_URL + '/' + v.coverUrl
        })
      })
    }
  }
}
